import React from 'react';
import Card from './Card';

const CardList = ({robots}) =>{

	return(

	<div>
    	{

    		robots.map((user , i)=>{
		return <Card key = {i} id = {robots[i].id} name = {robots[i].name} email = {robots[i].email}/>
	})
    		
    	} {/*we are using braces around card component because this is js not html*/}	
  	</div>
	);

	 


}

export default CardList;